import axios from "axios";
export default {
  AUTH_REQUEST({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login
      commit("AUTH_REQUEST");
      let data = {
        scope: "*",
        client_id: "2",
        password: user.pass,
        email: user.email,
        grant_type: "password",
        client_secret: "uRc5VM6JO0ayHfslXD35m2oKZnJ01mBuV8nlbfZL"
      };
      axios
        .post("/api/login", data)
        .then(resp => {
          const token = resp.data.data.access_token;
          localStorage.setItem("auth_token", token);
          window.axios.defaults.headers.common["authorization"] =
            "Bearer " + token;
          window.axios.defaults.headers.common["X-Requested-With"] =
            "XMLHttpRequest";
          commit("AUTH_SUCCESS", token);
          dispatch("getCurrentUser").then(resolve(resp));
        })
        .catch(err => {
          commit("AUTH_ERROR", err);
          localStorage.removeItem("auth_token");
          reject(err);
        });
    });
  },

  getCurrentUser({ commit }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("user")
        .then(resp => {
          commit("setCurrentUser", resp.data);
          localStorage.setItem("currentUser", JSON.stringify(resp.data));
          resolve(resp.data);
        })
        .catch(err => reject(err));
    });
  },

  // adding or Editing user record to DB
  userFormSubmit({ dispatch, commit }, user) {
    if (!user.edit) {
      window.axios
        .post("users/", user)
        .then(response => {
          dispatch("getUsers"); //reload all user from DB
          commit(
            "showSnackbar",
            {
              stateType: "success",
              text: ";اطلاعات موفقانه ثبت شد.",
              show: true
            },
            { root: true }
          ); // showing success dialog
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      window.axios
        .put("users/" + user.id, user)
        .then(response => {
          dispatch("getUsers"); //reload all user from DB
          commit(
            "showModel",
            { component: "userForm", show: false },
            { root: true }
          ); //closing card form
          commit(
            "showSnackbar",
            {
              stateType: "success",
              text: "اطلاعات موفقانه ویرایش شد.",
              show: true
            },
            { root: true }
          ); // showing success dialog
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  // delete user record from DB
  deleteUser({ dispatch, commit }, id) {
    window.axios
      .delete("users/" + id)
      .then(response => {
        if (response.success) {
          dispatch("getUsers"); //reload all users from DB
          commit(
            "showSnackbar",
            {
              stateType: "success",
              text: "کاربر موفقانه حذف شد.",
              show: true
            },
            { root: true }
          ); // showing success dialog
        } else {
          commit(
            "showSnackbar",
            {
              stateType: "error",
              text: response.msg,
              show: true
            },
            { root: true }
          ); // showing success dialog
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  // delete role record from DB
  deleteRole({ dispatch, commit }, id) {
    window.axios
      .delete("roles/" + id)
      .then(response => {
        if (response.success) {
          dispatch("getRoles"); //reload all roles from DB
          commit(
            "showSnackbar",
            { stateType: "success", text: "رول موفقانه حذف شد.", show: true },
            { root: true }
          ); // showing success dialog
        } else {
          commit(
            "showSnackbar",
            { stateType: "error", text: response.msg, show: true },
            { root: true }
          ); // showing success dialog
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
